import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { facilities } from '../data/mock';

const Facilities = () => {
  return (
    <section id="facilities" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#F5C842]/20 text-[#8B0000] border-[#F5C842]/30">
            Fasilitas Premium
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Fasilitas <span className="text-[#8B0000]">Terlengkap</span> untuk Kenyamanan Anda
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kami menyediakan fasilitas terbaik untuk memastikan perjalanan ibadah Anda nyaman dan berkesan
          </p>
        </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {facilities.map((facility, index) => {
            const Icon = LucideIcons[facility.icon];
            return (
              <Card 
                key={index}
                className="group hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#F5C842] overflow-hidden"
              >
                <CardContent className="p-6 text-center">
                  {/* Icon Container */}
                  <div className="relative mb-6 inline-block">
                    <div className="absolute inset-0 bg-[#8B0000]/5 rounded-2xl blur-xl group-hover:bg-[#F5C842]/20 transition-all duration-300"></div>
                    <div className="relative w-20 h-20 mx-auto bg-gradient-to-br from-[#8B0000]/10 to-[#F5C842]/10 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-10 h-10 text-[#8B0000]" strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#8B0000] transition-colors">
                    {facility.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {facility.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 max-w-4xl mx-auto">
          <Card className="bg-gradient-to-r from-[#8B0000] to-[#A52A2A] border-0 shadow-2xl">
            <CardContent className="p-8 md:p-12 text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                All-Inclusive Package
              </h3>
              <p className="text-white/90 text-lg mb-6">
                Semua fasilitas sudah termasuk dalam paket. Tidak ada biaya tambahan yang tersembunyi. 
                Fokus pada ibadah Anda, biarkan kami yang mengurus sisanya.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Badge className="bg-white/20 text-white border-white/30 px-4 py-2 text-sm">
                  ✓ Tiket Pesawat PP
                </Badge>
                <Badge className="bg-white/20 text-white border-white/30 px-4 py-2 text-sm">
                  ✓ Hotel Bintang 4-5
                </Badge>
                <Badge className="bg-white/20 text-white border-white/30 px-4 py-2 text-sm">
                  ✓ Makan 3x Sehari
                </Badge>
                <Badge className="bg-white/20 text-white border-white/30 px-4 py-2 text-sm">
                  ✓ Visa & Perlengkapan
                </Badge>
                <Badge className="bg-white/20 text-white border-white/30 px-4 py-2 text-sm">
                  ✓ Tour Guide
                </Badge>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Facilities;
